import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Calendar, User, ArrowRight } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await axios.get(`${API}/blogs`);
      setBlogs(response.data);
    } catch (error) {
      console.error('Error fetching blogs:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-24 md:py-32 bg-[#F8FAFC]">
        <div className="container mx-auto px-6 md:px-12 max-w-7xl">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl font-light tracking-tight text-[#0B1B32] mb-6" data-testid="blog-title">
              Insights & Updates
            </h1>
            <p className="text-xl text-slate-600 leading-relaxed">
              Market trends, quality standards, and industry insights from Vista Global Trade
            </p>
          </div>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="py-24 md:py-32 bg-white">
        <div className="container mx-auto px-6 md:px-12 max-w-7xl">
          {loading ? (
            <div className="text-center py-12">
              <p className="text-slate-600">Loading blog posts...</p>
            </div>
          ) : blogs.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-slate-600">No blog posts available yet.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogs.map((blog) => (
                <Link
                  key={blog.id}
                  to={`/blog/${blog.slug}`}
                  data-testid={`blog-card-${blog.slug}`}
                  className="group bg-white border border-slate-100 hover:border-slate-300 hover:shadow-2xl transition-all duration-500 overflow-hidden"
                >
                  <div className="relative h-56 overflow-hidden">
                    <img 
                      src={blog.image_url} 
                      alt={blog.title} 
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="inline-block bg-[#0B1B32] text-white px-3 py-1 text-xs font-medium">
                        {blog.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-4 text-sm text-slate-500 mb-3">
                      <span className="flex items-center gap-1">
                        <Calendar size={14} />
                        {formatDate(blog.published_at)}
                      </span>
                      <span className="flex items-center gap-1">
                        <User size={14} />
                        {blog.author}
                      </span>
                    </div>
                    <h3 className="text-xl font-medium text-[#0B1B32] mb-3 line-clamp-2">
                      {blog.title}
                    </h3>
                    <p className="text-slate-600 text-sm mb-4 line-clamp-3 leading-relaxed">
                      {blog.excerpt}
                    </p>
                    <span className="inline-flex items-center gap-2 text-[#0B1B32] font-medium group-hover:gap-4 transition-all duration-300">
                      Read More <ArrowRight size={18} />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Blog;